import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import ProductCard from '../components/ProductCard';
import { products } from '../data/products';
import CategoryCard from '../components/CategoryCard';
import { categories } from '../data/categories';
const Home = () => {
  return (
    <div>
      {/* Hero Section */}
      <HeroSection />
      
      {/* Products Section */}
      <section id="products" className="section-padding bg-gray-50">
        <div className="container-custom">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4">
              Nos Délices
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Découvrez notre sélection artisanale de douceurs, 
              élaborée avec passion et expertise.
            </p>
          </div>
          
          {/* Products Grid */}
          <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="grid gap-6">
            {categories.map((category) => (
              <CategoryCard key={category.id} category={category} />
            ))}
          </div>
        </div>
      </section>
        </div>
      </section>
      
      {/* About Preview */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Text Content */}
            <div className="space-y-6">
              <h2 className="text-4xl font-bold text-primary">
                L'Art de la <span className="text-accent">Douceur</span>
              </h2>
              
              <p className="text-lg text-gray-600 leading-relaxed">
                Pétales de Douceur crée des moments de bonheur 
                à travers ses créations chocolatées. Chaque produit est 
                élaboré avec passion et expertise pour éveiller vos sens.
              </p>
              
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <i className="fas fa-check-circle text-primary text-xl"></i>
                  <span className="font-medium">Ingrédients de bonne qualité 100% </span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="fas fa-check-circle text-primary text-xl"></i>
                  <span className="font-medium">Fabrication artisanale</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="fas fa-check-circle text-primary text-xl"></i>
                  <span className="font-medium">Livraison gratuite à partir de 80€ </span>
                </div>
              </div>
              
              <Link to="/about" className="inline-block btn-primary">
                <i className="fas fa-book-open"></i>
                Notre Histoire
              </Link>
            </div>
            
            {/* Image */}
            <div className="relative">
              <div className="bg-gradient-to-br from-primary to-accent rounded-3xl p-8 transform rotate-1">
                <div className="bg-white rounded-2xl overflow-hidden shadow-2xl transform -rotate-1">
                  <div className="aspect-video bg-gradient-to-r from-secondary to-white flex items-center justify-center">
                    <div className="text-center p-8">
                      <i className="fas fa-heart text-6xl text-primary mb-4"></i>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;